import React from 'react';
import { Dashboard } from '@components/common/Dashboard';
import { PageLayout } from '@components/common/PageLayout';
import { DashboardBackButton } from '@components/utils';
import { SECTION_NAMES } from '@constants/sectionNames';
import { Button, ButtonClean, HeadContent, Icon, Loading, Tag } from '@fourthwall/components';
import { NewWindowIcon } from '@fourthwall/icons';
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop';
import { routing } from '@utils/routing';
import { ConnectBar } from '../../components/ConnectBar/ConnectBar';
import { YouTubeVideoEntry } from '../../components/YouTubeVideoEntry/YouTubeVideoEntry';
import { mapStatusToTagProps } from '../../utils/mapStatusToTagProps';
import * as S from './AppsVimmi.styled';
import { useVimmi } from './hooks/useVimmi';
export const AppsVimmi = () => {
    const { connectBar, status, isLoading, hmac } = useVimmi();
    const { currentShop } = useCurrentShop();
    if (!connectBar || !currentShop) {
        return React.createElement(Loading, { isLoading: isLoading });
    }
    const renderStatusTag = () => {
        if (status === 'CONNECTED')
            return null;
        const props = mapStatusToTagProps(status);
        if (!props)
            return null;
        return React.createElement(Tag, { ...props, size: "large", display: "inline-flex" });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Vimmi" }),
        React.createElement(PageLayout, { size: "tiny" },
            React.createElement(Dashboard.Section, { name: "Vimmi Video Commerce", topContent: React.createElement(DashboardBackButton, { label: SECTION_NAMES.apps, to: routing.apps.self }), bottomContent: React.createElement("p", null,
                    React.createElement(ButtonClean, { label: "Learn More", href: routing.external.vimmi.learnMore, target: "_blank" })) },
                React.createElement(Loading, { isLoading: isLoading },
                    renderStatusTag(),
                    React.createElement(S.DescriptionWrapper, null, "Drive more sales with live shopping and shoppable videos embedded on your site and shared across your social channels."),
                    React.createElement(S.VideoWrapper, null,
                        React.createElement(YouTubeVideoEntry, { title: "Boost Your Sales with Shoppable Videos", videoId: "MDcG4H_QV_k", description: "Learn to transform live shopping events and shoppable videos into powerful sales tools that engage and convert.", size: "regular" })),
                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } },
                        React.createElement(ConnectBar, { ...connectBar }),
                        status === 'CONNECTED' && (React.createElement("div", { style: { padding: 16 } },
                            React.createElement("p", null,
                                React.createElement(Button, { appearance: "primary", label: "Launch Vimmi & Start Selling!", icon: React.createElement(Icon, { component: NewWindowIcon, height: 16, width: 16 }), href: `${routing.external.vimmi.dashboard}?source=fourthwall&hmac=${hmac?.signature}&timestamp=${hmac?.timestamp}&shop_id=${currentShop.id}`, target: "_blank" }))))))))));
};
